export default __webpack_public_path__ + "static/media/firstMore.aeba849c.png";